// Role-based permission helpers — single source of truth. Reads role from
// localStorage so UI and store guards share the same answer without prop drilling.
//
// Why this exists: after the 2026-04 data-integrity cleanup, organizers are
// locked out of the write paths that were causing 2,548 duplicate links,
// 146 unreported disputes, etc. They keep READ access + dispute evidence.

export const getUserRole = (): string => localStorage.getItem('userRole') ?? '';

export const isAdmin     = () => getUserRole() === 'admin';
export const isOrganizer = () => getUserRole() === 'organizer';
export const isGuide     = () => getUserRole() === 'guide';

// Write gates — organizer is EXPLICITLY blocked from pilgrim/link mutations.
// Admins keep everything; guides keep only their own link actions.
export const canUploadPilgrims      = () => isAdmin();
export const canCreateLink          = () => isAdmin();
export const canBulkLink            = () => isAdmin();
export const canBulkTransfer        = () => isAdmin();
export const canDeleteLink          = () => isAdmin();
export const canToggleOwnership     = () => isAdmin();
export const canAssignGuideToLink   = () => isAdmin();

// Dispute evidence — organizers KEEP this. They still need to defend claims
// that were moved into proper disputes by the cleanup.
export const canSubmitEvidence   = () => isAdmin() || isOrganizer() || isGuide();
export const canViewDisputes    = () => true;

// Guide management — organizers keep it; it's their own sub-team.
export const canManageOwnGuides  = () => isAdmin() || isOrganizer();
